import Vue from 'vue';
import VueI18n from 'vue-i18n';
// import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en'; // element-ui lang
// import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elemenGrLocale from 'element-ui/lib/locale/lang/el';
import enLocale from './en';
import grLocale from './gr';

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  gr: {
    ...grLocale,
    ...elemenGrLocale
  }
};

const i18n = new VueI18n({
  locale: localStorage.appLanguage || 'en', // set locale
  messages, // set locale messages
  silentTranslationWarn: true
});

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js